module.exports = __webpack_public_path__ + "static/media/cronos-token-logo.7448e300.svg";